import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { Timeout } from './timeout.component';
import { selectEndTimestamp } from '../../../../modules/snackbar/snackbar.selectors';
import { AuthActions } from '../../../../modules/auth';
import { selectIsBookingActive, BookingActions } from '../../../../modules/booking';
import { withKeyboardClose } from '../../HOC/withKeyboardClose';

const mapStateToProps = createStructuredSelector({
  isBookingActive: selectIsBookingActive,
  endTimestamp: selectEndTimestamp,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      signOut: AuthActions.signOut,
      closeBooking: BookingActions.closeBooking,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter,
  withKeyboardClose
)(Timeout);
